import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {RestResponse} from "../model/rest-response";
import {environment} from "../../environments/environment";
import {Observable} from "rxjs";
import {AgentTip} from "../model/agent-tip";

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  private _constants = {};

  constructor(private http: HttpClient) { }

  submitTip(agentTip: AgentTip): Observable<RestResponse> {
    return this.http.post<RestResponse>(environment.serverUrl + '/pay/agent-tip', agentTip);
  }

  createAppleSession(validationUrl: string): Observable<RestResponse> {
    return this.http.post<RestResponse>(environment.serverUrl + '/pay/create-apple-session', {
      'validationUrl': validationUrl
    });
  }

  loadApplePaySession(url) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', environment.serverUrl + '/pay/create-apple-session');
      xhr.onload = function () {
        if (this.status >= 200 && this.status < 300) {
          resolve(JSON.parse(xhr.response));
        } else {
          reject({
            status: this.status,
            statusText: xhr.statusText
          });
        }
      };
      xhr.onerror = function () {
        reject({
          status: this.status,
          statusText: xhr.statusText
        });
      };
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.send(JSON.stringify({validationUrl: url}));
    });
  }

  authorize(token) {
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', environment.serverUrl + '/pay/authorize');
      xhr.onload = function () {
        if (this.status >= 200 && this.status < 300) {
          resolve(xhr.response);
        } else {
          reject({
            status: this.status,
            statusText: xhr.statusText
          });
        }
      };
      xhr.onerror = function () {
        reject({
          status: this.status,
          statusText: xhr.statusText
        });
      };
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.send(JSON.stringify(token));
    });
  }
}
